import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import Input from '@cobliteam/ui/form/Input';
import { useState } from 'react';
import { SearchIcon } from './SearchIcon';

interface GlobalSearchTriggerProps {
  autoFocus?: boolean;
  onOpen: () => void;
}

const isMac = /macintosh|mac os x/i.test(navigator.userAgent);

const GlobalSearchTrigger = ({ autoFocus = false, onOpen }: GlobalSearchTriggerProps) => {
  const { t } = useTranslation('global-search');
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <div className='relative w-full min-w-0 max-w-[426px] max-[960px]:hidden'>
        <div data-visual-test='blackout' className='relative flex h-9 w-full min-w-0 items-center rounded-lg border border-gray-6 bg-white'>
          <Input
            data-testid='global-search-input'
            className='h-[34px] w-full min-w-0 justify-between border-none bg-transparent pr-12'
            loading={false}
            disabled={false}
            autoFocus={autoFocus}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            startIcon={<SearchIcon isHovered={isHovered} />}
            placeholder={t('search.placeholder')}
            onClick={onOpen}
          />
          <kbd className='absolute right-2 inline-flex h-5 max-h-full items-center rounded border border-gray-5 bg-gray-2 px-1 font-medium text-gray/80 text-xs shadow-sm'>
            {isMac ? '⌘' : 'Ctrl'} + K
          </kbd>
        </div>
      </div>

      <Button
        variant='outlined'
        color='default'
        size='sm'
        aria-label={t('command.title')}
        className='shrink-0 min-[961px]:hidden'
        icon={<SearchIcon isHovered={isHovered} className='text-gray-11' />}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onOpen}
      />
    </>
  );
};

export default GlobalSearchTrigger;
